module.exports = __webpack_public_path__ + "images/emoji/busstop.8a98fd59a5d0bca69b1e.png";